/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { ActivityType, ActivityStatus } from "../../global/Enum";
//import { toast } from 'react-toastify';
import AuthService from '../../providers/AuthService';
//import Utilities from "../../global/Utilities";

class ActivityItem extends Component {

  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    //toast.configure();
  }

  render() {

    const { activity, showMenu } = this.props;
    const session = AuthService.getSession();
    // const notify = () => {
    //   toast.info('Start the day to make any changes.')
    // }

    if (showMenu === undefined && showMenu) {
      showMenu = false
    }

    if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
      return (
        <li>
          <div>
            <div style={{ cursor: 'pointer' }}
              className={
                activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT
                  ? "fod-list-item yellow"
                  : activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION
                    ? "fod-list-item brown"
                    : activity.activity_type_id === ActivityType.GROUP_MEETING
                      ? "fod-list-item blue"
                      : "fod-list-item green"
              }
              data-toggle="modal"
              data-target={activity.activity_status_id === 1 && activity.activity_type_id === 3 && activity.assigned_user_id === session?.user?.user_id ? "#joinGroupMeeting" : null}
              data-dismiss="modal"
              onClick={() => this.props.getActivityItem(activity)}
            >
              <div className="title-and-status">
                <div className="title-description">
                  <span className="fod-id">{activity.activity_tag}</span>
                  <span className={(activity.activity_type_id === ActivityType.GROUP_MEETING && activity.activity_status_id === 1 ? "fod-desc group-mobile" : "d-none")}>
                    <i className="customic mobile-icon mr-1"></i>
                    {activity?.reporting_mobile}

                  </span>
                  {/* <span className={(activity.activity_type_id === ActivityType.GROUP_MEETING?"fod-mobile":"d-none")}>{this.state.mobileNumber}</span> */}
                  <span className="fod-title">{activity.activity_type_name}</span>
                  <span className="fod-desc">{activity.crop_name + ", " + activity.hybrid_name + " | " + activity.village_name}</span>
                </div>

                <div className="status">
                  <span
                    className={
                      activity.activity_status_id === 1 ? "to-start"
                        : activity.activity_status_id === 3 ? "completed"
                          : activity.activity_status_id === 4 ? "to-resubmit"
                            : activity.activity_status_id === 5 ? "completed"
                              : "in-progress"
                    }
                  >
                    {activity.activity_status_id === 3 ? ActivityStatus.COMPLETED :
                      activity.activity_status_id === 4 ? ActivityStatus.TO_RESUBMIT :
                        activity.activity_status_id === 5 ? ActivityStatus.COMPLETED :
                          ActivityStatus.TO_START}
                  </span>
                </div>
              </div>

              <div className="option-reviews">
                <div className="options">
                  <div style={{ display: "block" }}>
                    {
                      (showMenu || (activity?.user_id === session?.user?.user_id && activity.activity_status_id === 1))
                        ? <div className="dropdown-toggle"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <a><i className="customic ic-menu-more" ></i></a>
                        </div>
                        : <a><i className="customic ic-go-button" data-parent="#accordion"></i></a>
                    }

                    <div className="menu-more-options dropdown-menu p-0" data-toggle="dropdown" aria-labelledby="dropdownMenuButton">
                      <a className="dropdown-item d-inline-block"
                        onClick={(e) => this.props.handleDelete(e, activity)}>Delete</a>
                      <a className="dropdown-item d-inline-block"
                        onClick={(e) => this.props.handleActivitiesEdit(e, activity)}>Edit</a>
                    </div>

                  </div>
                </div>

                <div className="reviews">
                  <i
                    className={
                      activity.activity_status_id === 5
                        ? "customic ic-accepted"
                        : activity.activity_status_id === 4
                          ? "customic ic-rejected"
                          : activity.activity_status_id === 3
                            ? "customic ic-inprogress1"
                            : "d-none"
                    }
                  ></i>
                  {/* {activity.fdo_review === 0 ? <a>Review</a> : null} */}
                </div>
              </div>

            </div>
          </div>
        </li>

      );

    } else {
      return (
        <li>
          <div>
            <div style={{ cursor: 'pointer' }}
              className={
                activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT
                  ? "fod-list-item yellow"
                  : activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION
                    ? "fod-list-item brown"
                    : activity.activity_type_id === ActivityType.GROUP_MEETING
                      ? "fod-list-item blue"
                      : "fod-list-item green"
              }
              data-toggle="modal"
              data-target={(activity.activity_status_id === 1 && activity.activity_type_id !== 4) && activity.assigned_user_id === session?.user?.user_id ? "#homeFarmerMobileModal" : null}
              data-dismiss="modal"
            //onClick={() => this.props.getActivityItem(activity)}
            >
              <div className="title-and-status" style={{ flex: 'auto' }}
                onClick={() => this.props.getActivityItem(activity)}>
                <div className="title-description">
                  <span className="fod-id">{activity.activity_tag}</span>
                  <span className="fod-title">{activity.activity_type_name}</span>
                  <span className="fod-desc">{activity.crop_name + ", " + activity.hybrid_name + " | " + activity.village_name}</span>
                </div>

                <div className="status">
                  <span
                    className={
                      activity.activity_status_id === 1 ? "to-start"
                        : activity.activity_status_id === 3 ? "completed"
                          : activity.activity_status_id === 4 ? "to-resubmit"
                            : activity.activity_status_id === 5 ? "completed"
                              : "in-progress"
                    }
                  >
                    {activity.activity_status_id === 3 ? ActivityStatus.COMPLETED :
                      activity.activity_status_id === 4 ? ActivityStatus.TO_RESUBMIT :
                        activity.activity_status_id === 5 ? ActivityStatus.COMPLETED :
                          ActivityStatus.TO_START}
                  </span>
                </div>
              </div>

              <div className="option-reviews">
                <div className="options">
                  <div style={{ display: "block" }}>
                    {
                      (showMenu || (activity?.user_id === session?.user?.user_id && activity.activity_status_id === 1))
                        ? <div className="dropdown-toggle"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <a><i className="customic ic-menu-more" ></i></a>
                        </div>
                        : <a><i className="customic ic-go-button"></i></a>
                    }

                    <div className="menu-more-options dropdown-menu p-0" data-toggle="dropdown" aria-labelledby="dropdownMenuButton">
                      <a className="dropdown-item d-inline-block"
                        onClick={(e) => this.props.handleDelete(e, activity)}>Delete</a>
                      <a className="dropdown-item d-inline-block"
                        onClick={(e) => this.props.handleActivitiesEdit(e, activity)}>Edit</a>
                    </div>
                  </div>

                </div>
                <div className="reviews">
                  <i className={
                    activity.activity_status_id === 5
                      ? "customic ic-accepted"
                      : activity.activity_status_id === 4
                        ? "customic ic-rejected"
                        : activity.activity_status_id === 3
                          ? "customic ic-inprogress1"
                          : "d-none"
                  }>
                  </i>

                </div>
              </div>

            </div>
          </div>
        </li>

      );
    }


  }
};

export default withRouter(ActivityItem);
